import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  appStore: {
    id: 'studio.tkC3xo',
    defaultMessage: 'App store',
  },
  blockStore: {
    id: 'studio.6Y13Gl',
    defaultMessage: 'Block store',
  },
  organizations: {
    id: 'studio.JD2pwH',
    defaultMessage: 'Organizations',
  },
  documentation: {
    id: 'studio.isGKnz',
    defaultMessage: 'Documentation',
  },
  training: {
    id: 'studio./+axU7',
    defaultMessage: 'Training',
  },
});
